module.exports = flarum.core.compat['uikit/forum/DiscussionSearch'];